

const padZero = (num) => String(num).padStart(2, '0');

export const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";

    let processedDateString = String(dateString).trim();

    const parts = processedDateString.match(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2}):(\d{2})/);
    if (parts) {
        const day = parts[1];
        const month = parts[2];
        const year = parts[3];
        const hour = parts[4];
        const minute = parts[5];
        const second = parts[6];
        processedDateString = `${year}-${month}-${day}T${hour}:${minute}:${second}Z`;
    } else {
        if (processedDateString.includes(' ') && !processedDateString.includes('T')) {
            processedDateString = processedDateString.replace(' ', 'T') + 'Z';
        } else if (!processedDateString.endsWith('Z') && processedDateString.includes('T')) {
            processedDateString = processedDateString + 'Z';
        }
        else if (processedDateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
            processedDateString += 'T00:00:00Z';
        }
    }

    const date = new Date(processedDateString);

    if (!isNaN(date.getTime())) {
        const localDay = padZero(date.getDate());
        const localMonth = padZero(date.getMonth() + 1);
        const localYear = date.getFullYear();
        const localHours = padZero(date.getHours());
        const localMinutes = padZero(date.getMinutes());
        const localSeconds = padZero(date.getSeconds());

        return `${localDay}-${localMonth}-${localYear} ${localHours}:${localMinutes}:${localSeconds}`;
    }
    return "N/A";
};